import { useState } from 'react';
import { Box, Button } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useOfferEvaluationStepFromUrl } from '../hooks';
import { STEPS } from '../steps';

export default function StepperActions({
    switchPage = true,
    disabledNext = false,
    disabledPrevious = false,
    onNextClick,
}: {
    switchPage?: boolean;
    disabledNext?: boolean;
    disabledPrevious?: boolean;
    onNextClick?: () => Promise<boolean> | boolean | void;
}) {
    const { t } = useTranslation();
    const [activeStep, setActiveStep] = useOfferEvaluationStepFromUrl();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const handleNext = async () => {
        // If 'Finish' is clicked, navigate back to the list page
        if (activeStep === STEPS.length - 1) {
            navigate('/tender/offer-evaluations');
            return;
        }

        setLoading(true);
        if (!onNextClick || (await onNextClick())) {
            if (switchPage) {
                setActiveStep(activeStep + 1);
            }
        }
        setLoading(false);
    };
    const handleBack = () => setActiveStep(activeStep - 1);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
            <Button
                variant="outlined"
                disabled={disabledPrevious || activeStep === 0}
                onClick={handleBack}
                startIcon={<ArrowBack />}
            >
                {t('Back')}
            </Button>
            <Button
                variant="contained"
                disabled={disabledNext}
                onClick={handleNext}
                loading={loading}
                endIcon={<ArrowForward />}
            >
                {activeStep !== STEPS.length - 1 ? t('Next') : t('Finish')}
            </Button>
        </Box>
    );
}
